import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HomeCareList from '../Components/home-care-list';
import '../home-care.scss';

export class HomeCare extends Component {
  static propTypes = {
    lot: PropTypes.object
  };

  render() {
    return (
      <div className='home-care-wrapper'>
        <HomeCareList lot={this.props.lot} />
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

export default withRouter(connect(mapStateToProps)(HomeCare));



// WEBPACK FOOTER //
// ./src/HomeCare/Containers/home-hub-home-care.js